export default "__VITE_ASSET__731eac74__"